import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { AUTHENTICATION_CODE_LENGTH, Source } from '../constants';
import { RequiredValidator } from '../../../ui/gzForm/validators/required.validator';
import { FixedLengthValidator } from '../../../ui/gzForm/validators/fixed-length.validator';
import { NumericValidator } from '../../../ui/gzForm/validators/numeric.validator';
import { ElementClass, elementClassListAdd, elementClassListRemove } from '../../../utils/htmlElement.utils';
import { TemplateState } from '../../../types/common/types';

export class TerminalView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');

    this.dom.$startSessionContainer = this.shadow.querySelector('#start-session-container');
    this.dom.$terminalContainer = this.shadow.querySelector('#terminal-container');
    this.dom.$endSessionContainer = this.shadow.querySelector('#end-session-container');

    this.dom.$startSessionTitle = this.shadow.querySelector('#start-session-title');
    this.dom.$endSessionTitle = this.shadow.querySelector('#end-session-title');
    this.dom.$startSessionInfoFirstLine = this.shadow.querySelector('#start-session-info-first-line');
    this.dom.$startSessionInfoSecondLine = this.shadow.querySelector('#start-session-info-second-line');

    this.dom.$authenticationCodeInput = this.shadow.querySelector('#authentication-code');

    this.dom.$startSessionButton = this.shadow.querySelector('#start-session-button');
    this.dom.$startSessionButtonTooltip = this.shadow.querySelector('#start-session-button-tooltip');

    this.dom.$endSessionTitle = this.shadow.querySelector('#end-session-title');
    this.dom.$endSessionInfo = this.shadow.querySelector('#end-session-info');

    this.dom.$sessionStartTimeLabel = this.shadow.querySelector('#session-start-time-label');
    this.dom.$sessionStartTimeContent = this.shadow.querySelector('#session-start-time-content');
    this.dom.$sessionEndTimeLabel = this.shadow.querySelector('#session-end-time-label');
    this.dom.$sessionEndTimeContent = this.shadow.querySelector('#session-end-time-content');

    this.dom.$restartSessionButton = this.shadow.querySelector('#restart-session-button');
    this.dom.$downloadArchiveButton = this.shadow.querySelector('#download-archive-button');
    this.dom.$redirectUserInfo = this.shadow.querySelector('#redirect-user-info');

    this.getTranslations();
    this.setTranslatedStrings();
  }

  getTranslations() {
    this.translations = this.stringsTranslator.getTerminalTranslations();

    return this.translations;
  }

  translateNirvanaErrorCode(errorCode) {
    return this.stringsTranslator.translateNirvanaErrorCode(errorCode);
  }

  public setTranslatedStrings() {
    this.dom.$startSessionTitle.innerText = this.translations.startSessionTitle;
    this.dom.$endSessionTitle = this.translations.endSessionTitle;
    this.dom.$startSessionInfoFirstLine.innerText = this.translations.startSessionInfo.firstLine;
    this.dom.$startSessionInfoSecondLine.innerText = this.translations.startSessionInfo.secondLine;

    this.dom.$authenticationCodeInput.label = this.translations.authenticationCodeLabel;
    this.dom.$authenticationCodeInput.Input.placeholder = this.translations.inputPlaceholder;

    this.dom.$startSessionButton.textContent = this.translations.startSessionButtonText;
    this.dom.$endSessionInfo.innerHTML = this.translations.endSessionInfoText;

    this.buildLabelText(this.dom.$sessionStartTimeLabel, this.translations.sessionStartTimeLabel);
    this.buildLabelText(this.dom.$sessionEndTimeLabel, this.translations.sessionEndTimeLabel);

    this.dom.$restartSessionButton.textContent = this.translations.restartSessionButtonText;
    this.dom.$downloadArchiveButton.textContent = this.translations.downloadArchiveButtonText;
    this.dom.$redirectUserInfo.textContent = this.translations.redirectUserInfo;
  }

  buildLabelText(item, text) {
    item.querySelector('gz-tooltip').tooltipText = text;
    item.querySelector('span').innerHTML = text + ':';
  }

  buildSuccessView(data) {
    if (this.dependencies.user.source === Source.SOURCE_SSO_SAML) {
      elementClassListAdd(this.dom.$startSessionInfoSecondLine, ElementClass.HIDDEN);
      elementClassListRemove(this.dom.$redirectUserInfo, ElementClass.HIDDEN);
    } else {
      elementClassListRemove(this.dom.$authenticationCodeInput, ElementClass.HIDDEN);
      this.dom.$authenticationCodeInput.Validators = [
        RequiredValidator(this.commonStrings.requiredField),
        NumericValidator(this.dependencies.translateFn('Code must contain only digits.')),
        FixedLengthValidator(
          AUTHENTICATION_CODE_LENGTH,
          this.dependencies.translateFn('Code must have {authCodeMaxLength} characters.', {
            authCodeMaxLength: AUTHENTICATION_CODE_LENGTH,
          })
        ),
      ];
    }
  }

  public buildErrorView() {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }
}
